import { StyleSheet, View } from "react-native";
import { ThemedText } from "@/components/ThemedText";
import useAuth from "@/hooks/useAuth";
import Constants from "expo-constants";
import * as Updates from "expo-updates";
import * as Application from "expo-application";
import Animated from "react-native-reanimated";
import { useTheme } from "@/hooks/useTheme";
import Head from "expo-router/head";

const nativeVersion = Application.nativeBuildVersion;
const runtimeVersion = Constants.manifest2?.runtimeVersion;
const updateChannel = Updates.channel;
const node_env = process.env.NODE_ENV || "null";

export interface Tenant {
  id: string;
  name: string;
  created_at: string;
}

export default function AboutPage() {
  const { colors } = useTheme();
  const { signOut } = useAuth();

  return (
    <>
      <Head>
        <title>RockForce About</title>
        <meta name="description" content="" />
      </Head>
      <Animated.ScrollView>
        <View style={[{ borderColor: colors.border }, styles.stepContainer]}>
          <View style={styles.containerFirst}>
            <ThemedText type="subtitle">Positions</ThemedText>
            <ThemedText type="thin">Pre-defined positions for shifts</ThemedText>
          </View>
          <View
            style={{
              flex: 1,
              gap: 8,
              flexGrow: 1,
              flexDirection: "row",
              flexWrap: "wrap",
              alignContent: "space-between",
              flexBasis: "50%",
            }}
          ></View>
        </View>
        <ThemedText>runtime version: {runtimeVersion}</ThemedText>
        <ThemedText>native version: {nativeVersion}</ThemedText>
        <ThemedText>update channel: {updateChannel}</ThemedText>
        <ThemedText>node environment: {node_env}</ThemedText>
        <ThemedText onPress={signOut}>Sign Out</ThemedText>
      </Animated.ScrollView>
    </>
  );
}

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  stepContainer: {
    gap: 16,
    flexDirection: "row",
    flexWrap: "wrap",
    paddingBottom: 16,
    borderBottomWidth: 1,
  },
  tabNameInput: {
    flex: 1,
    flexDirection: "row",
    gap: 8,
    alignItems: "center",
    flexGrow: 1,
    flexBasis: "100%",
  },
  labelStyle: {
    flexBasis: 100,
    fontSize: 16,
  },
  containerFirst: {
    flex: 1,
    gap: 8,
    flexBasis: "10%",
    flexGrow: 1,
  },
  reactLogo: {
    height: 178,
    width: 290,
    bottom: 0,
    left: 0,
    position: "absolute",
  },
});
